import React, { useEffect, useState, useRef } from "react";

import * as DOMPurify from "dompurify";

import { Col, Container, Row } from "react-bootstrap";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Stack,
  Typography,
  Snackbar,
  TextField,
  IconButton,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import { ContentCopy, Delete, AddCircle } from "@mui/icons-material";
import DialogPaper from "./dialogPaper";

export default function ShareDialog(props) {
  const [selectedType, setSelectedType] = useState("0");
  const [snackOpen, setSnackOpen] = useState(false);
  const textAreaRef = useRef(null);

  const hideModal = () => {
    props.onHide();
  };

  const shareContent = () => {
    return (
      <Row>
        <Col xs={12}>
          <Typography className="mb-3">
            {props.sharePrompt ||
              "This is a public link that enables you to share the asset with your client, no login required."}
          </Typography>
        </Col>
        <Col xs={11}>
          <div className="form-group">
            <TextField
              ref={textAreaRef}
              id="presentation-link"
              multiline
              disabled={!props.shareLink}
              maxRows={4}
              value={props.shareLink}
              sx={{
                "& .MuiInputBase-input": {
                  pointerEvents: !props.shareLink ? "none" : "all",
                },
                width: "100%",
              }}
            />
          </div>
        </Col>
        <Col xs={1}>
          <IconButton
            disabled={!props.shareLink}
            sx={{ float: "right" }}
            aria-label="copy"
            onClick={() => {
              copyToClipboard(props.shareLink);
            }}
          >
            <ContentCopy />
          </IconButton>
        </Col>
      </Row>
    );
  };

  const copyToClipboard = (string) => {
    navigator.clipboard.writeText(string);
    setSnackOpen(true);
  };

  return (
    <>
      <Dialog
        open={props.modalVisible}
        onClose={() => hideModal}
        className="ps-modal share-modal"
        maxWidth="lg"
        fullWidth={true}
        PaperComponent={DialogPaper}
      >
        <Box className="ps-modal-title dialog-draggable-handle">
          <Container fluid>
            <Row className="align-items-center">
              <Col xs={12} sm={9}>
                <Typography variant="h3" owner="admin" color="adminText.dark">
                  {`Sharing & access (${props.title})`}
                </Typography>
              </Col>
              <Col xs={12} sm={3}>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                >
                  <Button
                    variant="outlined"
                    owner="admin"
                    dialogbtn="true"
                    dialogvariant="cancel"
                    className="lh"
                    onClick={() => {
                      hideModal();
                    }}
                  >
                    <Typography variant="button" owner="admin" className="lh">
                      Close
                    </Typography>
                  </Button>
                  {/* <Button
                    variant="contained"
                    owner="admin"
                    dialogbtn="true"
                    dialogvariant="save"
                    className="lh"
                    onClick={() => {
                      // save
                      if (!isPermissionsLoading) {
                        updatePermissions();
                      }
                    }}
                  >
                    <Typography variant="button" owner="admin" className="lh">
                      {isPermissionsLoading ? "Loading" : "Save"}
                    </Typography>
                  </Button> */}
                </Stack>
              </Col>
            </Row>
          </Container>
        </Box>

        <DialogContent>
          <Box className="ps-modal-content">
            <Container fluid>
              <Row className="mb-3">
                <Col>
                  <Tabs
                    value={selectedType}
                    onChange={(event, newValue) => {
                      setSelectedType(newValue);
                    }}
                    aria-label="Access"
                  >
                    <Tab
                      className={props.hideShare ? "d-none" : ""}
                      value={"0"}
                      label={
                        <Typography
                          variant="subtitle2"
                          owner="admin"
                          sx={{
                            textTransform: "none",
                          }}
                        >
                          Share link
                        </Typography>
                      }
                    />
                  </Tabs>
                </Col>
              </Row>
              <Row className="ps-relative">
                <Col className={selectedType === "0" ? `` : `d-none`}>
                  {props.shareLink && shareContent()}
                </Col>
                {/* <Col className={selectedType === "1" ? `` : `d-none`}>
                  {isPermissionsLoading && (
                    <Box className="circular-container fs">
                      <CircularProgress />
                    </Box>
                  )}
                  <Row>
                    <Col xs={12}>
                      <Typography
                        variant="body2"
                        owner="admin"
                        className="mb-3"
                        color="adminText.main"
                      >
                        Use this feature to give view, edit or delete access to
                        your presentation to a colleague.
                      </Typography>
                    </Col>
                  </Row>
                  <Box className="bordered">
                    <Row>
                      <Col xs={12} sm={4}>
                        <section className="users-section">
                          <div className="form-group">
                            <Row>
                              <Col>
                                <Typography
                                  variant="subtitle2"
                                  owner="admin"
                                  color="adminPrimary.main"
                                  className="search-label"
                                  lh="x-wide"
                                >
                                  Search users
                                </Typography>
                              </Col>
                              <Col
                                xs={"auto"}
                                className="d-flex align-items-center mb-1"
                              >
                                {isSearching && <CircularProgress size={20} />}
                              </Col>
                            </Row>

                            <Row className="mb-1">
                              <Col>
                                <TextField
                                  key="name"
                                  id="user-search"
                                  label="Type a name"
                                  variant="outlined"
                                  autoComplete="off"
                                  onChange={(event) => {
                                    event.preventDefault();
                                    setSearch(event.target.value);
                                  }}
                                  value={searchTerm}
                                />
                              </Col>
                            </Row>

                            {users && users.length > 0 ? (
                              <div className="users-container">
                                {users.map((item, index) => {
                                  return (
                                    <div key={`user-${index}`}>
                                      {renderItem(item)}
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <>
                                {isPermissionsError && (
                                  <div className="error-message">
                                    <Typography
                                      variant="body2"
                                      owner="admin"
                                      color="adminText.main"
                                      weight="light"
                                    >
                                      {permissionsErrorMessage}
                                    </Typography>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </section>
                      </Col>
                      <Col xs={12} sm={8}>
                        <section className="users-section">
                          <div className="form-group">
                            <Row>
                              <Col>
                                <label
                                  style={{ opacity: 0 }}
                                  className="search-label"
                                >
                                  Current
                                </label>
                              </Col>
                            </Row>
                            <Row>{renderUsers(userPermissions)}</Row>
                          </div>
                        </section>
                      </Col>
                    </Row>
                  </Box>
                </Col>
                <Col className={selectedType === "2" ? `` : `d-none`}>
                  {isPermissionsLoading && (
                    <Box className="circular-container fs">
                      <CircularProgress />
                    </Box>
                  )}
                  <Row>
                    <Col xs={12}>
                      <Typography
                        variant="body2"
                        owner="admin"
                        className="mb-3"
                        color="adminText.main"
                      >
                        Use this feature to give view, edit or delete access to
                        your presentation to a colleague on a role basis.
                      </Typography>
                    </Col>
                  </Row>
                  <Box className="bordered">
                    <Row>
                      <Col xs={12}>
                        {renderRoles(rolePermissions, roleList)}
                      </Col>
                    </Row>
                  </Box>
                </Col>
                <Col className={selectedType === "3" ? `` : `d-none`}>
                  <Row>
                    <Col xs={12}>
                      <Typography className="mb-3">
                        <a
                          href={`${filesystem_root}/${subdomain}/presentations/${presentation.id}/${presentation.id}.pdf`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {`Click to download`}
                        </a>
                      </Typography>
                    </Col>
                  </Row>
                </Col> */}

                {/* <Col className={selectedType === '3' ? `` : `d-none`}>
                  {isPermissionsLoading && (
                    <Box className='circular-container fs'>
                      <CircularProgress />
                    </Box>
                  )}
                  <Row>
                    <Col xs={12}>
                      <Typography className='mb-3'>Use this feature to give view access to a group of users.</Typography>
                    </Col>
                  </Row>
                  <Box className='bordered'>
                    <Row>
                      <Col xs={12}>
                        {renderAccessCollections(accessCollectionPermissions, accessCollectionList)}
                      </Col>
                    </Row>
                  </Box>
                </Col> */}
              </Row>
            </Container>
          </Box>
        </DialogContent>

        <Snackbar
          open={snackOpen}
          autoHideDuration={3000}
          onClose={() => setSnackOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackOpen(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            Link copied!
          </Alert>
        </Snackbar>
      </Dialog>
    </>
  );
}
